import useApi from "_api/index";

const { createContext, useEffect, useContext, useState } = require("react");

const CarBrandsContext = createContext({ carBrands: [] });

export const CarBrandsProvider = ({ children }) => {
  const [carBrands, setCarBrands] = useState([]);

  useEffect(() => {
    const fetchCarBrands = async () => {
      try {
        const response = await useApi.car.getOptionCarBrands();
        if (response.success) {
          setCarBrands(response.data);
        }
      } catch (error) {
        console.error("Error fetching car brands:", error);
      }
    };
    fetchCarBrands();
  }, []);

  return (
    <CarBrandsContext.Provider value={{ carBrands }}>
      {children}
    </CarBrandsContext.Provider>
  );
};

export const useCarBrands = () => useContext(CarBrandsContext);
